<template>
  <div id="barContainer">
    <div style="position:absolute;top:0;left:0;background-color:var(--gray200);width:100%;height:100%;border-radius:100px;">
&nbsp;
    </div>
    <div
      id="valueBar"
      style="position:absolute;top:0;left:0;background-color:var(--brandPrimary);height:100%;border-radius:100px;"
    >
&nbsp;
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    value: {
      required: true
    },
    max: {
      required: true
    },
    height: {
      type: String,
      default: '4px',
    }
  },
}
</script>

<style scoped>
#valueBar {
  width: calc(v-bind(value) / v-bind(max) * 100%);
  transition: width 0.5s;
}
#barContainer {
  position: relative;
  height: v-bind(height);
}
</style>